"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.traceFn = exports.startSpan = exports.setSpan = exports.getCurrentSpan = exports.getTracer = void 0;
const api_1 = require("@opentelemetry/api");
const TRACER_NAME = process.env.OTEL_SERVICE_NAME || process.env.JAEGER_SERVICE_NAME || '';
let tracer;
function getTracer() {
    if (!TRACER_NAME)
        return;
    if (!tracer) {
        tracer = api_1.trace.getTracer(TRACER_NAME);
    }
    return tracer;
}
exports.getTracer = getTracer;
function getCurrentSpan() {
    return api_1.trace.getSpan(api_1.context.active());
}
exports.getCurrentSpan = getCurrentSpan;
function setSpan(span) {
    return api_1.trace.setSpan(api_1.context.active(), span);
}
exports.setSpan = setSpan;
function startSpan(name, options) {
    var _a;
    const span = (_a = getTracer()) === null || _a === void 0 ? void 0 : _a.startSpan(name, options);
    if (!span)
        return;
    api_1.trace.setSpan(api_1.context.active(), span);
    return span;
}
exports.startSpan = startSpan;
function traceFn(fnName, attributes) {
    return function absorbFn(fn) {
        return function executeFn(...args) {
            const tracerInstance = getTracer();
            if (!tracerInstance)
                return fn(...args);
            return tracerInstance.startActiveSpan(fnName, { attributes, kind: api_1.SpanKind.SERVER }, api_1.context.active(), fnSpan => {
                var _a, _b, _c;
                const result = fn(...args);
                function finalize() {
                    fnSpan.end();
                }
                if (typeof result === 'object' &&
                    typeof result['then'] === 'function') {
                    return (_c = (_b = (_a = result['then']) === null || _a === void 0 ? void 0 : _a.call(result, promiseResult => {
                        finalize();
                        return promiseResult;
                    })) === null || _b === void 0 ? void 0 : _b['catch']) === null || _c === void 0 ? void 0 : _c.call(_b, e => {
                        fnSpan.recordException(e);
                        fnSpan.setStatus({
                            code: api_1.SpanStatusCode.ERROR,
                            message: String(e.message || e),
                        });
                        finalize();
                        throw e;
                    });
                }
                finalize();
                return result;
            });
        };
    };
}
exports.traceFn = traceFn;
//# sourceMappingURL=index.js.map